import { render, staticRenderFns } from "./SBRadioGroup.html?vue&type=template&id=ad6c7afc&scoped=true&"
import script from "./SBRadioGroup.ts?vue&type=script&lang=ts&"
export * from "./SBRadioGroup.ts?vue&type=script&lang=ts&"
import style0 from "./SBRadioGroup.css?vue&type=style&index=0&id=ad6c7afc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad6c7afc",
  null
  
)

export default component.exports